import { useEffect, useRef, useState } from 'react'

interface ReturnType {
  isSticky: boolean
  stickyRef: React.RefObject<HTMLDivElement>
}

/**
 * This hook is used to determine if an element is reaching the top of the viewport and thus becomes sticky.
 * It uses the Intersection Observer API to observe the element and updates the state accordingly.
 */
const useIsElementSticky = (): ReturnType => {
  const [isSticky, setIsSticky] = useState(false)
  const stickyRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(entry.boundingClientRect.top <= 0)
      },
      { threshold: 1, root: null }
    )

    const currentRef = stickyRef.current
    if (currentRef) {
      observer.observe(currentRef)
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef)
      }
    }
  }, [])

  return { isSticky, stickyRef }
}

export default useIsElementSticky
